// Otimização de imagens — converte URLs do Unsplash/Supabase Storage pra
// formato WebP + tamanho apropriado, e gera srcset pra dispositivos retina.
//
// Por que importa: cada card do marketplace baixa uma foto de 1500+ KB
// quando precisaria de 60 KB. Em 4G isso é 1-3s a mais por scroll.

/**
 * Aplica WebP + largura desejada na URL.
 * Suporta Unsplash (que entende ?w=&q=&fm=webp&auto=format) e devolve
 * a URL original pra outros provedores (CDN do Supabase Storage, etc.)
 */
export function urlOtimizada(src, largura = 600, qualidade = 75) {
  if (!src || typeof src !== "string") return src;

  // Unsplash: aceita query params nativos
  if (src.includes("images.unsplash.com")) {
    const u = new URL(src);
    u.searchParams.set("w", String(largura));
    u.searchParams.set("q", String(qualidade));
    u.searchParams.set("fm", "webp");
    u.searchParams.set("auto", "format");
    u.searchParams.set("fit", "crop");
    return u.toString();
  }

  // via.placeholder.com — sem otimização disponível, mantém
  if (src.includes("via.placeholder.com")) return src;

  // Supabase Storage — pode aceitar query de transformação se o bucket tiver
  // o `image-transforms` enabled. Por ora deixamos passar.
  return src;
}

/**
 * Gera atributo srcset com 1x e 2x pra dispositivos retina.
 */
export function srcSetOtimizado(src, largura = 600) {
  const x1 = urlOtimizada(src, largura);
  const x2 = urlOtimizada(src, largura * 2);
  if (x1 === src) return undefined; // sem otimização aplicada → não emite srcset
  return `${x1} 1x, ${x2} 2x`;
}
